import React from "react"
import ReactDOM from "react-dom"
import ArticleColorUsp from "./article-color-usp-component"

export default class ArticleColorUspModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<ArticleColorUsp {...self.modelJson} modifier={"w--wider"} />, self.elem)
  }
}
